import React from "react";
import PropTypes from "prop-types";
import { isDate, isString } from "lodash";

import { format, isValid, parseISO } from "date-fns";
import { Label } from "semantic-ui-react";

export function DateText({ value, formatString, color, ...props }) {
  if (
    !value ||
    (isDate(value) && !isValid(value)) ||
    (isString(value) && !isValid(parseISO(value)))
  )
    return null;

  return (
    <Label basic color={color} data-test="date-text" {...props}>
      {format(isDate(value) ? value : parseISO(value), formatString)}
    </Label>
  );
}

DateText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  formatString: PropTypes.string,
  color: PropTypes.string,
};

DateText.defaultProps = {
  value: null,
  formatString: "MM/dd/yyyy h:mmaaaaa'm'",
  color: "grey",
};

export default DateText;
